import { environment } from 'environments/environment';

export class Configuration {
  static get() {
    return {
      apiBackend: environment.apiBackend,
      headerToken: 'X-AUTH-TOKEN',
      appsUrl: environment.appsUrl,
    }
  }
  static profile() {
      return {
        nama:'RSU QURE DIGITAL',
        namaPPK:'RSU QURE DIGITAL',
        alamat: '',
        link: '',
        kdRekananBPJS:0,
        kdKelompokBPJS:0,
      }
    
  }
}
